import { useEffect, useState } from 'react';
import { apiUser } from '../../api/apiUser.api';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useNavigate } from 'react-router-dom';

export function CheckIsBlocked({ userId, children }) {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [blocked, setBlocked] = useState({
    isBlocked: false,
    blockedByMe: false,
    blockedMe: false
  });

  useEffect(() => {
    if (!userId) return;
    apiUser.fetchCheckBlock(axiosPrivate, userId).then((res) => setBlocked(res.data));
  }, [userId]);

  return (
    <>
      {blocked.blockedMe && (
        <div
          className="fixed z-50 inset-0 backdrop-blur-md w-full h-full flex items-center justify-center"
          style={{
            marginTop: 'calc(var(--tg-content-safe-area-inset-top) + (var(--tg-content-safe-area-inset-top) * 0.7))'
          }}
        >
          <img
            src="/icons/Button-back.svg"
            alt="Назад"
            onClick={() => {
              navigate(-1);
            }}
            className="w-[44px] h-[44px] absolute top-4 left-4"
          />
          <div className="p-4">
            <img className="size-[80px] mx-auto mb-8 mt-5" src="/icons/blocked_success.svg" alt="blocked_success" />
            <p className="text-white text-center font-semibold text-[22px]">
              Данный пользователь вас заблокировал. Вы больше не сможете взаимодействовать с ним
            </p>
          </div>
        </div>
      )}
      {children}
    </>
  );
}
